// 오버레이 클릭 닫기 훅 — "armed-click" 패턴.
//
// 브라우저는 mousedown 지점과 mouseup 지점이 다르면 click 을 두 지점의 공통 조상에서
// 발화시킨다. 모달 카드 안에서 드래그를 시작해 오버레이 위에서 손을 떼면 공통 조상이
// 오버레이 자신이 되어, 카드의 stopPropagation 도 target 검증도 통과해 모달이 닫혀버린다.
// 이 훅은 "오버레이에서 눌렀고(onMouseDown) + 오버레이에서 뗐을 때(onClick)"만 닫아서
// 그 오닫힘만 제거한다. 일반 오버레이 클릭·모바일 탭(합성 클릭) 닫기는 기존과 동일.
//
// 사용: const overlayCloseProps = useOverlayClickClose(onClose);
//       <div style={overlayStyle} {...overlayCloseProps}> ... </div>
import { useRef } from 'react';

export function useOverlayClickClose(onClose) {
  const startedOnOverlay = useRef(false);
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;
  return {
    onMouseDown: (e) => {
      startedOnOverlay.current = e.target === e.currentTarget;
    },
    onClick: (e) => {
      const started = startedOnOverlay.current;
      startedOnOverlay.current = false;
      if (started && e.target === e.currentTarget) onCloseRef.current?.(e);
    },
  };
}

export default useOverlayClickClose;
